// extracted by mini-css-extract-plugin
export default {"overlay":"my-z","bodyOpen":"ny-z","content":"oy-z","header":"py-z","close":"qy-z","closeNoHeading":"ry-z"};